export default __webpack_public_path__ + "static/media/buying_documents.77e95da3.svg";